import { ReactNode, MouseEvent } from 'react';
import styled from '@emotion/styled';
import { themed, ITheme } from '../../themer';
import { CloseIcon } from '../Icon';
import { StyledInput } from '../Input';
import { Css } from '../../utils/Css';
import { useConfig } from '..';

export const StyledSearchInputClearWrap = styled.div<
	{ showClearIcon: boolean },
	ITheme
>`
	position: relative;

	${StyledInput} {
		padding-right: ${themed(({ input }, { showClearIcon }) =>
			showClearIcon
				? Css.calc(input.padding, (value: number) => value + 24)
				: '',
		)};
	}
`;

export const StyledClearIcon = styled.button<{}, ITheme>`
	position: absolute;
	cursor: pointer;
	height: 100%;
	right: 0px;
	top: 0px;
	padding: ${themed(({ search }) => search.clear.padding)};
	border: ${themed(({ search }) => search.clear.border)};
	background: ${themed(({ search }) => search.clear.background)};

	&:focus {
		outline: 2px solid transparent;

		${CloseIcon} g {
			stroke: ${themed(({ color }) => color.highlight)};
		}
	}

	${CloseIcon} {
		height: 100%;
	}
`;

interface ISearchInputClearWrapProps {
	onClickClear: (e: MouseEvent) => void;
	showClearIcon: boolean;
	children: ReactNode;
}

export function SearchInputClearWrap({
	showClearIcon,
	onClickClear,
	children,
}: ISearchInputClearWrapProps) {
	const { translations } = useConfig();

	return (
		<StyledSearchInputClearWrap showClearIcon={showClearIcon}>
			{children}
			{showClearIcon && (
				<StyledClearIcon
					type="button"
					aria-label={translations.clearSearchLabel}
					onClick={onClickClear}
				>
					<CloseIcon />
				</StyledClearIcon>
			)}
		</StyledSearchInputClearWrap>
	);
}
